var _style, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage11Layer1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 549.9 449.9",
    style: {
      enableBackground: "new 0 0 549.9 449.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#037A9A;}\r\n\t.st1{fill:#A6F8F9;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.6,389.8H102v-16.6H85.6v16.6H69v16.4h16.6v16.6H102v-16.6h16.6V389.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M438.6,222.4h-61.1L289,310.8v61.1L438.6,222.4z M289,222.4v47.7l47.7-47.7L289,222.4L289,222.4z M509.8,222.4 h-30.5L289,412.6v30.5h30.5l190.3-190.3V222.4L509.8,222.4z M509.8,293.6L360.3,443.2h61.1l88.5-88.4v-61.2L509.8,293.6z  M509.8,443.2v-47.7l-47.7,47.7H509.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.2,30.3c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8s-1.7-3.8-3.8-3.8C5.9,26.5,4.2,28.2,4.2,30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.2,74.6c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8C5.9,70.7,4.2,72.5,4.2,74.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.2,118.8c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8C5.9,115,4.2,116.7,4.2,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.2,163.1c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8C5.9,159.2,4.2,160.9,4.2,163.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.2,207.3c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8C5.9,203.4,4.2,205.2,4.2,207.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.2,251.5c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8C5.9,247.7,4.2,249.4,4.2,251.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.2,295.8c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8C5.9,291.9,4.2,293.6,4.2,295.8 z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 45,
    cy: 30.3,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 45,
    cy: 74.6,
    r: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.1,118.8c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C42.9,115,41.1,116.7,41.1,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.1,163.1c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C42.9,159.2,41.1,160.9,41.1,163.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.1,207.3c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C42.9,203.4,41.1,205.2,41.1,207.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.1,251.5c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C42.9,247.7,41.1,249.4,41.1,251.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 45,
    cy: 295.8,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 81.9,
    cy: 30.3,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 81.9,
    cy: 74.6,
    r: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.1,118.8c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C79.8,115,78.1,116.7,78.1,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.1,163.1c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C79.8,159.2,78.1,160.9,78.1,163.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.1,207.3c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C79.8,203.4,78.1,205.2,78.1,207.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.1,251.5c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C79.8,247.7,78.1,249.4,78.1,251.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 81.9,
    cy: 295.8,
    r: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115,30.3c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8s-1.7-3.8-3.8-3.8C116.7,26.5,115,28.2,115,30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115,74.6c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8C116.7,70.7,115,72.5,115,74.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115,118.8c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8C116.7,115,115,116.7,115,118.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115,163.1c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C116.7,159.2,115,160.9,115,163.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115,207.3c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C116.7,203.4,115,205.2,115,207.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115,251.5c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C116.7,247.7,115,249.4,115,251.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115,295.8c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C116.7,291.9,115,293.6,115,295.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.9,30.3c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8s-1.7-3.8-3.8-3.8C153.6,26.5,151.9,28.2,151.9,30.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.9,74.6c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C153.6,70.7,151.9,72.5,151.9,74.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.9,118.8c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C153.6,115,151.9,116.7,151.9,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.9,163.1c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C153.6,159.2,151.9,160.9,151.9,163.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.9,207.3c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C153.6,203.4,151.9,205.2,151.9,207.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.9,251.5c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C153.6,247.7,151.9,249.4,151.9,251.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.9,295.8c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C153.6,291.9,151.9,293.6,151.9,295.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 192.7,
    cy: 30.3,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 192.7,
    cy: 74.6,
    r: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.8,118.8c0,2.1,1.7,3.8,3.8,3.8s3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8S188.8,116.7,188.8,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.8,163.1c0,2.1,1.7,3.8,3.8,3.8s3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8S188.8,160.9,188.8,163.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.8,207.3c0,2.1,1.7,3.8,3.8,3.8s3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8S188.8,205.2,188.8,207.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.8,251.5c0,2.1,1.7,3.8,3.8,3.8s3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8S188.8,249.4,188.8,251.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 192.7,
    cy: 295.8,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 229.6,
    cy: 30.3,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 229.6,
    cy: 74.6,
    r: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M225.8,118.8c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C227.5,115,225.8,116.7,225.8,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M225.8,163.1c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C227.5,159.2,225.8,160.9,225.8,163.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M225.8,207.3c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C227.5,203.4,225.8,205.2,225.8,207.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M225.8,251.5c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C227.5,247.7,225.8,249.4,225.8,251.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 229.6,
    cy: 295.8,
    r: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.7,30.3c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8s-1.7-3.8-3.8-3.8C264.4,26.5,262.7,28.2,262.7,30.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.7,74.6c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C264.4,70.7,262.7,72.5,262.7,74.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.7,118.8c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C264.4,115,262.7,116.7,262.7,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.7,163.1c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C264.4,159.2,262.7,160.9,262.7,163.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.7,207.3c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C264.4,203.4,262.7,205.2,262.7,207.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.7,251.5c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C264.4,247.7,262.7,249.4,262.7,251.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.7,295.8c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8 C264.4,291.9,262.7,293.6,262.7,295.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage11Layer1);
export default __webpack_public_path__ + "static/media/image-11-layer-1.8f090a393bc8a32c6b9fad25f80f2d0b.svg";
export { ForwardRef as ReactComponent };